import { Pipe, PipeTransform } from '@angular/core';
import { StoreViewModel } from '@models/api.models';
import { findStoreById } from '@features/reserve-in-store/helper/find-store-by-id';

@Pipe({
    name: 'findStoreFromId',
    standalone: true
})
export class FindStoreFromId implements PipeTransform {
    transform(stores: StoreViewModel[] | null, id: number | string): StoreViewModel | undefined {
        if (!stores) {
            return undefined;
        }
        return findStoreById(stores, id);
    }
}
